import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/atlassian-logo-blue-small.svg'


const _withScopeId = n => (_pushScopeId("data-v-dc25ab40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup" }
const _hoisted_2 = { class: "container signup__container" }
const _hoisted_3 = { class: "signup__container__logo" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Sign up for your account ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, " Already have an account? ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "atlassion-logo-blue-small"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_trello_logo = _resolveComponent("trello-logo")!
  const _component_signup_form = _resolveComponent("signup-form")!
  const _component_dotted_inline_list = _resolveComponent("dotted-inline-list")!
  const _component_auth_card = _resolveComponent("auth-card")!
  const _component_atlassian_footer = _resolveComponent("atlassian-footer")!
  const _component_global_footer = _resolveComponent("global-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_trello_logo, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'home' })))
        })
      ]),
      _createVNode(_component_auth_card, null, {
        title: _withCtx(() => [
          _hoisted_4
        ]),
        body: _withCtx(() => [
          _createVNode(_component_signup_form)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_dotted_inline_list, null, {
            a: _withCtx(() => [
              _hoisted_5
            ]),
            b: _withCtx(() => [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'login' })), ["prevent"]))
              }, " Log In ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_atlassian_footer, null, {
      "logo-slot": _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }),
    _createVNode(_component_global_footer)
  ]))
}